import { defineMessages } from 'react-intl';

export default defineMessages({
    CarouselHeader: {
        id: 'components.common.MultiCarouselComponent.CarouselHeader',
        defaultMessage: 'More from Saga {product} Insurance',
    },
    CarouselSubHeader: {
        id: 'components.common.MultiCarouselComponent.CarouselSubHeader',
        defaultMessage: 'There\'s plenty to explore and learn about our {product} insurance cover.'
    }
});
